module.exports = __webpack_public_path__ + "img/arrows-repeat-1.3adc6300.svg";